import o from "./highrise1322.mjs";
function u(f, e) {
  var n = e ? o(f.buffer) : f.buffer;
  return new f.constructor(n, f.byteOffset, f.length);
}
export {
  u as default
};
